import { translate } from "app/language/service"
import { IRootState } from "app/model"
import { getInventory } from "form/inventory/tools/common"
import { state as mapState } from "form/map/state"
import {
  onInventoryMapContainerMove,
  onInventoryMapContainerResize,
  setInventoryMapVisibility
} from "form/map/tools/inventory"
import React from "react"
import { connect } from "react-redux"
import { FloatingPanel } from "ui/components/FloatingPanel"
import { InventoryMap } from "./InventoryMap"

interface IInventoryMapFloatingPanelProps {
  isMapVisible: boolean
}

const InventoryMapFloatingPanelFn = React.memo(({ isMapVisible }: IInventoryMapFloatingPanelProps) => {
  if (!isMapVisible) {
    return null
  }
  return (
    <FloatingPanel
      resizable
      initialWidth={`${mapState.inventory.width}px`}
      initialHeight={`${mapState.inventory.height}px`}
      minWidth="270px"
      minHeight="270px"
      initialPosition={mapState.inventory.initialPositionInPixel}
      initialMaximized={mapState.inventory.isMaximized}
      title={translate("label.forecast")}
      onClose={() => setInventoryMapVisibility(false)}
      onResize={(w: number, h: number, isMaximized: boolean) => onInventoryMapContainerResize(w, h, isMaximized)}
      onMoveStop={position => onInventoryMapContainerMove(position)}>
      <InventoryMap />
    </FloatingPanel>
  )
})

export const InventoryMapFloatingPanel = connect(
  (state: IRootState): IInventoryMapFloatingPanelProps => ({
    isMapVisible: state.app.activeContext ? getInventory(state).isMapVisible : false
  })
)(InventoryMapFloatingPanelFn)
